<template>
    <layout :showuserinfo="false" title="Tambah Hak Milik" :crumbs="crumbs">

    <center>
        <w-tabs :items="pooo"  :no-slider="false" active-class="primary" center>
            <template #item-content.1>
                <z-page title="Semak Hak Milik Dari SPTB" :append-button="true">
                    <w-flex class="justify-end">
                        <div class="xs4 mr3">
                            <w-select
                                class="mb3 daerah"
                                :items="districts"
                                v-model="form.kod_daerah"
                                outline
                                label="Pilih Daerah"
                                label-position="left"
                                @input="daerah()"
                            >
                            </w-select>
                        </div>
                    </w-flex>
                    <w-form @submit.prevent="semak">
                        <w-flex class="mt3" >
                            <div class="xs2 " >
                                <w-radio
                                    class="mr2"
                                    v-model="form.form_option"
                                    name="radio"
                                    return-value="option1"
                                >
                                    Barcode / No. Akaun
                                </w-radio>
                            </div>
                            <div class="xs6 mr3">
                                <w-input
                                    v-model="form.barcode"
                                    placeholder="Sila Masukkan Barcode"
                                    :disabled="form.form_option !== 'option1'"
                                    :validators="[validators.required]"
                                    maxlength="30"
                                ></w-input>
                            </div>
                        </w-flex>
                        <w-flex class="mt3" >
                            <div class="xs2 ">
                                <w-radio
                                    class="mr2"
                                    v-model="form.form_option"
                                    name="radio"
                                    return-value="option2"
                                >
                                    ID Hakmilik
                                </w-radio>
                            </div>
                            <div class="xs2 mr3">
                                <z-lookup
                                    :url="apiBaseUrl + '/mukim?kod_daerah=' + form.kod_daerah"
                                    :sort="false"
                                    :cache="false"
                                    v-model="form.kod_mukim"
                                    placeholder="Sila Pilih Kod Mukim"
                                    :validators="[validators.required]"
                                    :disabled="form.form_option !== 'option2'"
                                />
                            </div>
                            <div class="xs2 mr3">
                                <w-select
                                :validators="[validators.required]"
                                placeholder="Sila Pilih Jenis Hakmilik"
                                v-model="form.kod_jenis_hm"
                                :items="jhm"
                                :disabled="form.form_option !== 'option2'"
                                />
                            </div>
                            <div class="xs2 mr3">
                                <w-input
                                    v-model="form.no_hakmilik"
                                    :model-value="
                                        form.form_option !== 'option2' ? '' : form.no_hakmilik
                                    "
                                    placeholder="Sila Masukkan No. Hakmilik"
                                    :disabled="form.form_option !== 'option2'"
                                    :validators="[
                                        form.form_option === 'option2'
                                            ? validators.required
                                            : null,
                                    ]"
                                >
                                </w-input>
                            </div>
                        </w-flex>
                        <div class="d-flex justify-end mt3">
                            <w-button class="my1 mr0" type="submit" :loading="searching">
                                Semak
                            </w-button>
                        </div>
                    </w-form>
                    <w-card v-if="hakMilik.H_PGNHM !=null">
                        <table class="table-dashboard" width="100%"  loading="loading">
                            <thead>
                                <tr>
                                    <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:30%; ">Maklumat</td>
                                    <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:70%; ">Perkara</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                     <td>No Hakmilik</td>
                                     <td>{{this.hakMilik.H_PGNHM}}</td>
                                 </tr>
                                 <tr>
                                     <td>Hakmilik Asal</td>
                                     <td>{{this.hakMilik.H_HMASAL ?? 'Tiada'}}</td>
                                    </tr>

                                <tr>
                                     <td>Hakmilik Sebelum Kini</td>
                                     <td>{{this.hakMilik.H_HMSKINI ?? "Tiada"}}</td>
                                 </tr>
                                <tr>
                                     <td>Hakmilik Berikut</td>
                                     <td>{{this.hakMilik.H_HMBERIKUT ?? 'Tiada'}}</td>
                                 </tr>
                                <tr>
                                    <td>Tarikh Daftar</td>
                                    <td v-if="this.hakMilik.H_TKHDAF !=null">{{ moment(this.hakMilik.H_TKHDAF).format("DD-MM-YYYY")}}</td>
                                    <td v-else>Tiada</td>
                                </tr>
                                <tr>
                                    <td>Tarikh Daftar Hakmilik Asal</td>
                                    <td v-if="this.hakMilik.H_TKHDAFASL !=null">{{ moment(this.hakMilik.H_TKHDAFASL).format("DD-MM-YYYY")}}</td>
                                    <td v-else>Tiada</td>
                                </tr>
                                <tr>
                                     <td>Tarikh Batal</td>
                                     <td v-if="this.hakMilik.H_TKHBATAL !=null">{{ moment(this.hakMilik.H_TKHBATAL).format("DD-MM-YYYY")}}</td>
                                     <td v-else>Tiada</td>
                                </tr>
                                <tr>
                                     <td>Kegunaan Tanah</td>
                                     <td>{{this.hakMilik.H_SYARAT ?? 'Tiada'}}</td>
                                 </tr>
                                <tr>
                                     <td>Syarat Tanah</td>
                                     <td>{{this.hakMilik.syarat ?? 'Tiada'}}</td>
                                 </tr>
                                <tr>
                                     <td>Cukai</td>
                                     <td>{{Number(this.hakMilik.H_CUKAI).toFixed(2) ?? 'Tiada'}}</td>
                                 </tr>
                                 <tr>
                                     <td>Status</td>
                                     <td>{{this.hakMilik.H_STATUS ?? 'Tiada'}}</td>
                                </tr>
                                 <tr>
                                     <td>Kod Lot</td>
                                     <td>{{this.hakMilik.H_KODLOT ?? 'Tiada'}}</td>
                                </tr>
                                <tr>
                                    <td>No Lot</td>
                                    <td>{{this.hakMilik.H_NOLOT ?? 'Tiada'}}</td>
                                </tr>
                                <tr>
                                    <td>Luas</td>
                                    <td>{{Number(this.hakMilik.H_LUAS).toFixed(4)}} {{this.hakMilik.H_ULUAS}}</td>
                                </tr>
                           </tbody>
                        </table>

                        <table class="mb2 table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Pemilik</td>
                                    <td>No. ID</td>
                                    <td>Jenis Pemilik</td>
                                    <td>Alamat 1</td>
                                    <td>Alamat 2</td>
                                    <td>Alamat 3</td>
                                </tr>
                            </thead>
                            <tbody v-if="masuk==true">
                                <tr v-for="pemiliks in pemilikSPTB">
                                        <td>{{ pemiliks.PB_NAMAPB1 }}</td>
                                        <td>{{ pemiliks.PB_NOPB }}</td>
                                        <td>{{ pemiliks.perihal.perihal }}</td>
                                        <td>{{ pemiliks.PB_ALAMATR1 }}</td>
                                        <td>{{ pemiliks.PB_ALAMATR2 }}</td>
                                        <td>{{ pemiliks.PB_ALAMATR3 }}</td>
                                </tr>
                            </tbody>
                            <center v-else>
                                <w-progress class="ma1" circle />
                            </center>
                        </table>
                    </w-card>
                </z-page>
            </template>
            <template #item-content.2>
                <w-card class="xs6">
                    <center><h2>TARIK DATA PEMILIKAN DARI SPTB</h2></center><br>
                  <w-form @submit.prevent="submit">
                    <div align="left" >
                        <p ><span style="color:red">*</span> Pastikan No Hakmilik Tersebut Wujud Di SPTB</p>
                        <p ><span style="color:red">*</span> Masukkan Maklumat Seperti Yang Dari SPTB</p>
                    </div>
                    <br>
                    <div>
                        <w-flex>
                            <w-input
                                class="mb5"
                                outline
                                label="No Hakmilik"
                                label-position="left"
                                type="text"
                                v-model="form.no_hm"
                                :validators="[validators.required]"
                                >
                            </w-input>

                        </w-flex>
                    </div>
                          <div class="d-flex justify-end mt3">
                            <w-button class="my1 mr0" type="submit" :loading="searching">
                              Simpan Hakmilik
                            </w-button>
                          </div>

                  </w-form>
                </w-card>
                <w-card class="xs6">
                    <p align="left"><span style="color:red">*</span>Sila Semak Butiran Cukai Hakmilik Selepas Pindahan Berjaya</p>
                    <p align="left"><span style="color:red">*</span>Sila Buat Semakan Cukai Tali Air Dengan Hakmilik Sebelum Jika Ada.</p>
                </w-card>
            </template>
        </w-tabs>


</center>
    </layout>
  </template>
  <script>
  import ZResource from "@/Modules/z-resource";
  import { Inertia } from "@inertiajs/inertia";
  import WaveUI from "wave-ui";
  import moment from "moment";
import Table from "../../Component/Table.vue";
  export default {
    extends: ZResource,
    data() {
        return {
            waveui: new WaveUI(),
            masuk:false,
            validators: { required: (value) => !!value || "Sila Isi Ruangan Ini", },
            districts: [{ label: "Loading", selected: true }],
            mukim: [{ label: "Loading", selected: true }],
            jhm: [{ label: "Loading", selected: true }],
            kod_lot: [{ label: "Loading", selected: true }],
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            searching: false,
            form: {
                no_hm: null,
                barcode: null,
                kod_daerah: "01",
                kod_jenis_hm: null,
                no_hakmilik: null,
                form_option: 'option1',
            },
            pooo: [
                { title: "Semakan Hakmilik SPTB", content: "" },
                { title: "Tarik SPTB", content: "" },
            ],
            jhm: [{ label: "Loading", value: null, selected: true }],
            districts: [{ label: "Loading", selected: true }],
            renderComponent: false,
            success: null,
            hakMilik:[],
            pemilikSPTB:[],
        };
    },
    methods: {
        async submit() {
            this.searching = true;
            await axios({
                method: "post",
                url: "https://ihasil.kedah.gov.my/api/integration-service/sptb/pindahan",
                responseType: "json",
                data: {
                    idHakmilik: this.form.no_hm,
                }
            }).then((e) => {

                if (e.data.message == `${this.form.no_hm} telah dikemaskini.`) {
                    this.getResit();
                    this.$waveui.notify({
                        success: true,
                        message: "Berjaya! Maklumat hak milik telah dikemaskini.",
                        timeout: 3000,
                    });
                    this.getResit();
                }
                else {
                    this.$waveui.notify({
                        error: true,
                        message: "Tiada Maklumat",
                        timeout: 3000,
                    });
                }
                this.hakMilik.items=e.data.pemilikan;
            }).finally((e) => {
                this.searching = false;
                // this.update();
            });
        },
        async getResit(){
            const url=`${this.apiBaseUrl}/cukai/tambah_hm?no_hm=${this.form.no_hm}`;
            await axios({
                method: "get",
                url: url,
                responseType: "json"
            });
        },
        async update() {
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/tambah_hm`,
                responseType: "json",
                data: this.form,
            }).then((e) => {
                console.log(e.data);
                // const url = `butiran-cukai?no_hm=${e.data}`;
                this.success = e.data.message;
                this.$waveui.notify({
                    success: true,
                    message: "Berjaya! Maklumat hak milik telah dikemaskini.",
                    timeout: 3000,
                });
            }).finally((e) => {
                this.searching = false;
            });
        },
        async daerah() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },
        async jenisHm() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenisHm`,
                responseType: "json",
            }).then((e) => {
                this.jhm = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },
        async semak() {
            var l = "";
            if (this.form.form_option == "option1") {
                var l = this.form.barcode;
            }
            else if (this.form.form_option == "option2") {
                var l = `02${this.form.kod_daerah}${this.form.kod_mukim}${this.form.kod_jenis_hm}${this.form.no_hakmilik}`;
            }
            this.searching = true;
            await axios({
                method: "get",
                url: `https://ihasil.kedah.gov.my/api/integration-service/sptb?q=${l}`,
                responseType: "json",
            }).then((e) => {
                if (e.data.pemilikan != null) {
                    this.$waveui.notify({
                        success: true,
                        message: "Berjaya! Maklumat Dikenalpasti.",
                        timeout: 3000,
                    });
                }
                else {
                    this.$waveui.notify({
                        error: true,
                        message: "Tiada Maklumat",
                        timeout: 3000,
                    });
                }
                this.hakMilik = e.data.pemilikan;
            }).finally((e) => {
                this.searching = false;
                // this.update();
            });

            this.masuk=false;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/pemilik`,
                responseType: "json",
                params:{
                    no_hm:l
                },
            }).then((e)=>{
                this.pemilikSPTB=e.data;
            }).finally((e) => {
                this.searching = false;
                this.masuk=true;
            });

            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenisLot`,
                responseType: "json",
                params:{
                    kod:this.hakMilik.H_KODLOT,
                },
            }).then((e)=>{
                this.hakMilik.H_KODLOT =e.data[0].keterangan;
            });
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/kegunaanSyarat`,
                responseType: "json",
                params:{
                    kod:this.hakMilik.H_SYARAT,
                },
            }).then((e)=>{
                this.hakMilik.syarat=this.hakMilik.H_SYARAT;
                this.hakMilik.H_SYARAT =e.data[0].keterangan;
            });
        }
    },
    created: function () {
        this.moment = moment;
    },
    mounted() {
        this.daerah();
        this.jenisHm();
    },
    components: { Table }
};
  </script>
